export default __webpack_public_path__ + "static/login-img-f682ca6587def5f6e89185cd9426da01.png";